import { render, staticRenderFns } from "./ModalDistribucionOcComponent.vue?vue&type=template&id=171d3560&"
import script from "./ModalDistribucionOcComponent.vue?vue&type=script&lang=js&"
export * from "./ModalDistribucionOcComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports